/**
 * Remove scroll progress bar
 * This script removes any scroll progress indicators that might be dynamically added
 */

(function() {
  'use strict';

  // Function to remove scroll progress elements
  function removeScrollProgressBar() {
    // Common class names and IDs for scroll progress bars
    const selectors = [
      '[class*="scroll-progress"]',
      '[class*="scrollprogress"]',
      '[class*="reading-progress"]',
      '[class*="scroll-indicator"]',
      '[id*="scroll-progress"]',
      '[id*="scrollprogress"]',
      '[id*="reading-progress"]',
      '[id*="scroll-indicator"]',
      '.scroll-progress-bar',
      '.scroll-progress-indicator',
      '.reading-progress-bar',
      '.scroll-indicator-bar'
    ];

    // Remove elements by selector
    selectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          // Check if element is fixed on the right side
          const style = window.getComputedStyle(el);
          if (style.position === 'fixed' && (style.right === '0px' || style.right === '0')) {
            el.remove();
          }
        });
      } catch (e) {
        // Ignore errors
      }
    });

    // Remove any dynamically added elements with inline styles indicating scroll progress
    const allElements = document.querySelectorAll('body > div');
    allElements.forEach(el => {
      const style = window.getComputedStyle(el);
      const inlineStyle = el.getAttribute('style') || '';
      
      // Check if it's a fixed element on the right with small width (scroll progress bar)
      if (
        style.position === 'fixed' &&
        (style.right === '0px' || style.right === '0') &&
        (parseInt(style.width) <= 10 || inlineStyle.includes('width:') && parseInt(inlineStyle.match(/width:\s*(\d+)px/)?.[1] || '999') <= 10) &&
        (style.height === '100%' || style.height === '100vh' || parseInt(style.height) > window.innerHeight * 0.5)
      ) {
        // Additional check: make sure it's not the back-to-top button or other important elements
        if (!el.classList.contains('back-to-top') && 
            !el.classList.contains('side-panel') &&
            !el.id.includes('cart') &&
            !el.id.includes('drawer')) {
          el.remove();
        }
      }
    });
  }

  // Remove on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeScrollProgressBar);
  } else {
    removeScrollProgressBar();
  }

  // Also remove after a short delay to catch dynamically added elements
  setTimeout(removeScrollProgressBar, 100);
  setTimeout(removeScrollProgressBar, 500);
  setTimeout(removeScrollProgressBar, 1000);

  // Remove any scroll event listeners that might be updating a progress bar
  // Note: This is a more aggressive approach and might affect other functionality
  // We'll only do this if we can identify the specific listener
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    // If it's a scroll listener that might be for a progress bar, we'll let it run
    // but we'll remove the element it's trying to update
    if (type === 'scroll') {
      const wrappedListener = function(...args) {
        try {
          listener.apply(this, args);
        } catch (e) {
          // Ignore errors
        }
        // Remove progress bar after scroll event
        setTimeout(removeScrollProgressBar, 10);
      };
      return originalAddEventListener.call(this, type, wrappedListener, options);
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
})();

